import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _class, _temp;

import React from 'react';
import { TouchableWithoutFeedback } from 'react-native';
import State from './State';

function handleHandlerStateChange(props, event, oldState, state) {
  var enabled = props.enabled,
      onHandlerStateChange = props.onHandlerStateChange;

  if (enabled !== false && onHandlerStateChange) {
    var _event$nativeEvent = event.nativeEvent,
        x = _event$nativeEvent.locationX,
        y = _event$nativeEvent.locationY,
        absoluteX = _event$nativeEvent.pageX,
        absoluteY = _event$nativeEvent.pageY;
    onHandlerStateChange({
      nativeEvent: {
        oldState: oldState,
        state: state,
        x: x,
        y: y,
        absoluteX: absoluteX,
        absoluteY: absoluteY,
        pointerInside: true
      }
    });
  }
}

function handleFailed(props, event) {
  handleHandlerStateChange(props, event, State.ACTIVE, State.FAILED);
}

function handleEnd(props, event) {
  handleHandlerStateChange(props, event, State.ACTIVE, State.END);
}

function handleActivate(props, event) {
  handleHandlerStateChange(props, event, State.BEGAN, State.ACTIVE);
}

function handleBegan(props, event) {
  handleHandlerStateChange(props, event, State.UNDETERMINED, State.BEGAN);
}

var UnimplementedGestureHandler =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UnimplementedGestureHandler, _React$Component);

  function UnimplementedGestureHandler() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UnimplementedGestureHandler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UnimplementedGestureHandler)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "setNativeProps", function () {// Do nothing
    });

    return _this;
  }

  _createClass(UnimplementedGestureHandler, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return UnimplementedGestureHandler;
}(React.Component);

var handlers = {
  NativeViewGestureHandler:
  /*#__PURE__*/
  function (_React$Component2) {
    _inherits(NativeViewGestureHandler, _React$Component2);

    function NativeViewGestureHandler() {
      _classCallCheck(this, NativeViewGestureHandler);

      return _possibleConstructorReturn(this, _getPrototypeOf(NativeViewGestureHandler).apply(this, arguments));
    }

    _createClass(NativeViewGestureHandler, [{
      key: "render",
      value: function render() {
        var children = this.props.children;
        return children;
      }
    }]);

    return NativeViewGestureHandler;
  }(React.Component),
  TapGestureHandler: (_temp = _class =
  /*#__PURE__*/
  function (_React$Component3) {
    _inherits(TapGestureHandler, _React$Component3);

    function TapGestureHandler() {
      var _getPrototypeOf3;

      var _this2;

      _classCallCheck(this, TapGestureHandler);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(TapGestureHandler)).call.apply(_getPrototypeOf3, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this2), "hasBegun", false);

      _defineProperty(_assertThisInitialized(_this2), "touchBank", []);

      _defineProperty(_assertThisInitialized(_this2), "timeout", null);

      _defineProperty(_assertThisInitialized(_this2), "clearState", function () {
        _this2.hasBegun = false;
        _this2.touchBank = [];
        window.clearTimeout(_this2.timeout);
      });

      _defineProperty(_assertThisInitialized(_this2), "handlePressIn", function (event) {
        var maxDelayMs = _this2.props.maxDelayMs;

        if (!_this2.hasBegun) {
          event.persist();
          _this2.hasBegun = true;
          handleBegan(_this2.props, event); // Cancel if not finished in time

          _this2.timeout = window.setTimeout(function () {
            if (_this2.hasBegun) {
              _this2.clearState();

              handleFailed(_this2.props, event);
            }
          }, maxDelayMs);
        }
      });

      _defineProperty(_assertThisInitialized(_this2), "handlePressOut", function (event) {
        var _event$touchHistory$t = event.touchHistory.touchBank,
            touchBank = _event$touchHistory$t === void 0 ? [] : _event$touchHistory$t;
        var _this2$props = _this2.props,
            maxDeltaX = _this2$props.maxDeltaX,
            maxDeltaY = _this2$props.maxDeltaY,
            maxDurationMs = _this2$props.maxDurationMs,
            numberOfTaps = _this2$props.numberOfTaps;
        _this2.touchBank = _this2.touchBank.concat(touchBank); // Check if all touches are valid

        var areTouchesValid = _this2.touchBank.every(function (touch) {
          var currentPageX = touch.currentPageX,
              currentPageY = touch.currentPageY,
              currentTimeStamp = touch.currentTimeStamp,
              startPageX = touch.startPageX,
              startPageY = touch.startPageY,
              startTimeStamp = touch.startTimeStamp; // Check if touch took longer than it may

          if (startTimeStamp + maxDurationMs < currentTimeStamp) {
            return false;
          } // Check if touch moved too far away


          if (startPageX + maxDeltaX < currentPageX || startPageX - maxDeltaX > currentPageX) {
            return false;
          } // Check if touch moved too far away


          if (startPageY + maxDeltaY < currentPageY || startPageY - maxDeltaY > currentPageY) {
            return false;
          }

          return true;
        }); // Check if all touches were valid and the necessary number of touches was achieved


        if (!areTouchesValid) {
          _this2.clearState();

          handleFailed(_this2.props, event);
        } else if (_this2.touchBank.length >= numberOfTaps) {
          handleActivate(_this2.props, event);

          _this2.clearState();

          handleEnd(_this2.props, event);
        }
      });

      return _this2;
    }

    _createClass(TapGestureHandler, [{
      key: "setNativeProps",
      value: function setNativeProps() {}
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            style = _this$props.style;
        return React.createElement(TouchableWithoutFeedback, {
          style: style,
          onPressIn: this.handlePressIn,
          onPressOut: this.handlePressOut
        }, children);
      }
    }]);

    return TapGestureHandler;
  }(React.Component), _defineProperty(_class, "defaultProps", {
    numberOfTaps: 1,
    maxDurationMs: 500,
    maxDelayMs: 500,
    minPointers: 1,
    maxDeltaX: Number.MAX_SAFE_INTEGER,
    maxDeltaY: Number.MAX_SAFE_INTEGER,
    maxDist: Number.MAX_SAFE_INTEGER
  }), _temp)
};
export default function createHandler(handlerName) {
  var propTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var Handler =
  /*#__PURE__*/
  function (_React$Component4) {
    _inherits(Handler, _React$Component4);

    function Handler() {
      var _getPrototypeOf4;

      var _this3;

      _classCallCheck(this, Handler);

      for (var _len3 = arguments.length, _args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        _args[_key3] = arguments[_key3];
      }

      _this3 = _possibleConstructorReturn(this, (_getPrototypeOf4 = _getPrototypeOf(Handler)).call.apply(_getPrototypeOf4, [this].concat(_args)));

      _defineProperty(_assertThisInitialized(_this3), "_refHandler", function (node) {
        _this3._viewNode = node;
      });

      _defineProperty(_assertThisInitialized(_this3), "setNativeProps", function () {
        var _this3$_viewNode;

        (_this3$_viewNode = _this3._viewNode).setNativeProps.apply(_this3$_viewNode, arguments);
      });

      return _this3;
    }

    _createClass(Handler, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!handlers[handlerName]) {
          console.warn("".concat(handlerName, " is not yet supported on web."));
        }
      }
    }, {
      key: "render",
      value: function render() {
        var Handler = handlers[handlerName] || UnimplementedGestureHandler;
        return React.createElement(Handler, _extends({
          ref: this._refHandler
        }, this.props));
      }
    }]);

    return Handler;
  }(React.Component);

  _defineProperty(Handler, "displayName", handlerName);

  _defineProperty(Handler, "propTypes", propTypes);

  return Handler;
}